import React from 'react';

const IconNetherlands = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55.2 38.4" {...props}>
      <g fillRule="evenodd" clipRule="evenodd">
        <path
          fill="#ae1c28"
          d="M3.03 0h49.13c1.67 0 3.03 1.36 3.03 3.03v32.33c0 1.66-1.36 3.02-3.02 3.03H3.02C1.36 38.4 0 37.03 0 35.37V3.03C0 1.36 1.36 0 3.03 0z"
        />
        <path fill="#fff" d="M0 12.8h55.2v25.57c0 1.67-1.36 3.03-3.03 3.03H3.03C1.36 38.4 0 37.04 0 35.37V12.8z" />
        <path
          fill="#21468b"
          d="M0 25.6h55.2v9.77c0 1.66-1.36 3.02-3.02 3.03H3.03A3.04 3.04 0 010 35.37V25.6z"
        />
      </g>
    </svg>
  );
};

export default IconNetherlands;
